import type { PaymentsTranslations } from "../interfaces/payments";

export const paymentsTranslations: PaymentsTranslations = {
  page_title: "Payment requests",
  button_back_to_list: "Back to list",
  button_new_payment: "New payment",
  section_new_payment_title: "New payment",
  button_create_payment: "Create payment",
  button_clear_form: "Clear form",
  button_cancel: "Cancel",
  toast_error_load: "Error loading payments",
  toast_error_load_more: "Error loading more payments",
  toast_success_create: "Payment created successfully",
  toast_error_create: "Error creating payment",
  toast_success_status: "Status updated successfully",
  toast_error_status: "Error updating status",
  toast_success_cancel: "Payment cancelled successfully",
  toast_error_cancel: "Error cancelling payment",
  toast_success_take: "Payment taken successfully",
  toast_error_take: "Error taking payment",
  toast_success_release: "Payment released and returned to pending",
  toast_error_release: "Error releasing payment",
  toast_success_notify: "Client notified successfully",
  toast_error_notify: "Error notifying client",
  loading: "Loading…",
  show_more: "Show more",
  alt_comprobante_pago: "Payment receipt",

  card_status_pending: "Pending",
  card_status_in_progress: "In progress",
  card_status_paid: "Paid",
  card_beneficiary: "Beneficiary:",
  card_platform: "Platform:",
  card_date: "Date:",
  card_creation_date: "Creation date:",
  card_update_date: "Update date:",
  card_note: "Note:",
  card_created_by: "Created by:",
  card_updated_by: "Updated by:",
  card_notify_client: "Client notified",
  toast_success_taker_reminder: "Reminder sent successfully",
  toast_error_taker_reminder: "Error sending reminder",
  card_url_has_label: "url_hash",
  card_network_label: "Network",
  card_copy: "Copy",
  card_copied: "Copied",
  card_copy_title: "Copy",
  card_cancel: "Cancel",
  card_take: "Take",
  card_take_continue: "Continue",
  card_taken_by: "Taken by {{name}}",
  card_taken_by_you: "You have taken this one",
  card_release: "Release",
  card_release_admin: "Release (admin)",
  card_release_title: "Return the payment to pending so another user can take it",
  card_view_history: "View history",
  card_verified: "Verified",
  card_payment_info: "Payment information",
  card_receipts: "Receipt",
  card_receipts_count: "Receipts",
  card_error_load: "Error loading",
  card_view: "View",
  card_alt_receipt_n: "Receipt {{n}}",

  preview_payer: "Payer:",
  preview_platform: "Platform:",
  preview_date: "Date:",
  preview_created_by: "Created by:",

  column_pending: "Pending",
  column_in_progress: "In progress",
  column_paid: "Paid",
  column_empty_pending: "No pending payments. New payments will appear here.",
  column_refresh: "Refresh",
  column_refresh_aria: "Refresh payments",
  column_drag_in_progress: "Drag to In progress",
  column_drag_paid: "Drag to Paid",

  modal_cancel_title: "Cancel payment",
  modal_cancel_description:
    "Please tell us why you want to cancel this payment. This action cannot be undone once confirmed.",
  modal_cancel_label_reason: "Cancellation reason",
  modal_cancel_placeholder: "Write the reason for cancellation here...",
  modal_cancel_back: "Back",
  modal_cancel_confirm: "Confirm cancellation",
  modal_cancel_confirming: "Cancelling...",
  modal_cancel_required: "The cancellation reason is required.",
  modal_cancel_close_aria: "Close",

  modal_take_title: "Take payment",
  modal_take_description:
    "Are you sure you want to take this payment? The payment will move to «In progress» and this action will be recorded in the history.",
  modal_take_back: "Back",
  modal_take_confirm: "Take",
  modal_take_processing: "Processing...",
  modal_take_close_aria: "Close",

  modal_release_title: "Release payment",
  modal_release_description:
    "The payment will go back to «Pending» and any operator will be able to take it. This action will be recorded in the history.",
  modal_release_confirm: "Release",
  modal_release_admin_title: "Release a payment held by another operator",
  modal_release_admin_description:
    "This payment is held by another operator. Releasing it removes their lock and sends the payment back to «Pending».",
  modal_release_admin_holder: "Held by {{name}}",
  modal_release_admin_warning:
    "They may be working on it right now. Only release it if the payment is stuck or the operator is unavailable.",
  modal_release_admin_confirm: "Release anyway",
  modal_release_back: "Back",
  modal_release_processing: "Releasing...",

  modal_paid_title: "Mark as paid",
  modal_paid_description:
    "Are you sure you want to mark this payment as paid? The payment will move to «Paid» and this action will be recorded in the history.",
  modal_paid_payment_source_label: "Bank exit",
  modal_paid_payment_source_placeholder: "Select bank exit",
  modal_paid_payment_source_required: "You must select the bank exit.",
  modal_paid_comprobante_label: "Receipt (images)",
  modal_paid_comprobante_optional_label: "Receipt (images) (optional)",
  modal_paid_comprobante_description: "PNG, JPG, WebP up to 10 MB. You can select multiple files.",
  modal_paid_comprobante_optional_description:
    "Optional for USDT. PNG, JPG, WebP up to 10 MB. You can select multiple files.",
  modal_paid_url_has_label: "url_hash",
  modal_paid_url_has_placeholder: "Enter url_hash",
  modal_paid_comprobante_required: "You must attach at least one receipt.",
  modal_paid_url_has_required: "The url_hash field is required for USDT payments.",
  modal_paid_back: "Back",
  modal_paid_confirm: "Mark as paid",
  modal_paid_processing: "Processing...",
  modal_paid_close_aria: "Close",

  modal_history_title: "Payment history",
  modal_history_loading: "Loading history…",
  modal_history_error: "Could not load history.",
  modal_history_empty: "No records in history.",
  modal_history_section_title: "Change history",
  modal_history_initial_status: "Initial status",
  modal_history_previous_status: "Previous status",
  modal_history_current_status: "Current status",
  modal_history_duration: "Duration",
  modal_history_close: "Close",
  modal_history_close_aria: "Close",
  status_pending: "Pending",
  status_in_progress: "In progress",
  status_paid: "Paid",
  status_cancelled: "Cancelled",
  status_archived: "Archived",
  status_filed: "Archived (filed)",
  change_type_created: "Creation",
  change_type_status: "Status change",
  change_type_data: "Data update",
  change_type_attachment: "Attachment added",
  change_type_note: "Note added",
  change_type_taken: "Taken",

  modal_info_title: "Payment information",
  modal_info_no_data: "No payment information for this record.",
  modal_info_amount_label: "Payment amount",
  modal_info_close: "Close",
  modal_info_confirm_payment: "Confirm payment",
  modal_info_copy_title: "Copy",
  modal_info_copy_amount_title: "Copy payment amount",
  modal_info_yes: "Yes",
  modal_info_no: "No",

  modal_info_field_llave_bre_b: "Bre-B Key",
  modal_info_field_numero_celular_nequi: "Mobile number associated with Nequi",
  modal_info_field_banco_ach: "Bank",
  modal_info_field_tipo_cuenta: "Account type",
  modal_info_field_numero_cuenta: "Account number",
  modal_info_field_tipo_documento: "Document type",
  modal_info_field_numero_documento: "Document number",
  modal_info_field_tipo_llave_pix: "Pix key type",
  modal_info_field_llave_pix: "Pix key",
  modal_info_field_clabe: "CLABE (18 digits)",
  modal_info_field_banco: "Bank",
  modal_info_field_rut: "RUT",
  modal_info_field_email: "Email",
  modal_info_field_numero_cci: "CCI number",
  modal_info_field_documento_identidad: "Identity document",
  modal_info_field_numero_celular_yape: "Mobile number associated with Yape",
  modal_info_field_numero_celular_plin: "Mobile number associated with Plin",
  modal_info_field_routing_number: "Routing number",
  modal_info_field_swift_bic: "SWIFT / BIC",
  modal_info_field_direccion_banco: "Bank address",
  modal_info_field_email_telefono_zelle: "Email or phone number associated",
  modal_info_field_iban: "IBAN",
  modal_info_field_tipo_identificador_fps: "Identifier type",
  modal_info_field_identificador_fps: "FPS identifier",
  modal_info_field_codigo_chats: "CHATS code",
  modal_info_field_id_alipay: "Alipay ID",
  modal_info_field_id_wechat: "WeChat ID",
  modal_info_field_numero_cuenta_iban: "IBAN account number",
  modal_info_field_numero_celular: "Mobile number",
  modal_info_field_cbu_cvu: "CBU or CVU",
  modal_info_field_cbu: "CBU",
  modal_info_field_cvu: "CVU",
  modal_info_field_direccion_wallet: "Wallet address",
  modal_info_field_binance_pay_uid: "UID",
  modal_info_field_binance_pay_email: "Email",

  validation_method_field_required: "This field is required.",

  form_payer_subclient_placeholder: "Select payer (sub-client)",

  form_client_search_empty_message:
    "No clients matched your search. Register them in the Clients module and try again.",
  form_client_search_go_to_clients: "Go to Clients",
  form_client_search_dropdown_empty: "No results for this search.",

  form_payer_accounts_loading: "Loading beneficiary accounts…",
  form_payer_accounts_missing:
    "The beneficiary must have at least one registered account. Please go to the Clients module and register one.",
  form_payer_account_label: "Beneficiary account",
  form_payer_account_placeholder: "Select an account",
  validation_payer_account_required: "Please select the beneficiary account.",

  form_method_section_title: "Payment method details",
  form_method_select_placeholder: "Select {{label}}...",
  form_method_pix_select_type_first: "Select the key type first",
  form_method_option_ahorros: "Savings",
  form_method_option_corriente: "Checking",
  form_method_option_nit: "Nit",
  form_method_option_cc: "Cc",
  form_method_option_ce: "Ce",
  form_method_option_pasaporte: "Passport",
  form_method_option_ppt: "Ppt",
  form_method_option_cpf: "CPF",
  form_method_option_cnpj: "CNPJ",
  form_method_option_email: "Email",
  form_method_option_telefono: "Phone",
  form_method_option_llave_aleatoria: "Random key",
  form_method_option_id_fps: "ID FPS",

  pending_totals_title: "Pending totals by currency",
  pending_totals_subtitle: "Get an at-a-glance view of the total amount left to process in each currency.",
  pending_totals_card_label: "Pending total",
  pending_totals_loading: "Loading totals…",
  pending_totals_empty: "There are no pending payments at this time.",
  pending_totals_error: "Error loading pending totals",
  pending_totals_refresh: "Refresh",
  pending_totals_refresh_aria: "Refresh pending totals",
};
